const welcome = {
    title: 'Yönetici Paneline Hoş Geldiniz',
    description: 'Yönetici paneli, kodlama bilgisi olmadan JX Accountyu yönetmek için bir web uygulamasıdır. Önce, bir hesap oluşturalım. Bu hesapla JX Accountyu kendiniz veya şirketiniz adına yönetebilirsiniz.',
    create_account: 'Hesap Oluştur',
};
export default Object.freeze(welcome);
